import { Options } from '../options.interface';
import { JOB_API_CONFIG } from './job-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { buildUrl } from '@wizbii-utils/angular/core';
import { AdmiinJob, Company, Domain, Job, JobRequest, toAdmiinJob, toJob } from '@wizbii/utils/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JobWebservice {
  readonly http = inject(HttpClient);
  readonly jobApiConfig = inject(JOB_API_CONFIG);

  readonly baseUrl = this.jobApiConfig.baseUrl;

  get(id: string, options?: Options): Observable<Job> {
    return this.http.get<Record<string, unknown>>(`${this.baseUrl}/api/jobs/${id}?view=true`, options).pipe(map(toJob));
  }

  getAdmiin(id: string, options?: Options): Observable<AdmiinJob> {
    return this.http
      .get<Record<string, unknown>>(`${this.baseUrl}/api/admin/jobs/${id}`, options)
      .pipe(map(toAdmiinJob));
  }

  getBatch(ids: string[], options?: Options): Observable<Job[]> {
    const queryParam = ids.join(',');

    return this.http
      .get<Record<string, unknown>[]>(`${this.baseUrl}/api/jobs/${queryParam}`, options)
      .pipe(map((items) => items.map(toJob)));
  }

  updateAdmiinJob(job: JobRequest, options?: Options): Observable<AdmiinJob> {
    return this.http.post(buildUrl(`${this.baseUrl}/api/jobs`), job, options).pipe(map(toAdmiinJob));
  }

  getDomains(options?: Options): Observable<Domain[]> {
    return this.http.get<Domain[]>(buildUrl(`${this.baseUrl}/api/domains/jobs`), options);
  }

  deleteAllJobsByCompanyId(company: Company): Observable<unknown> {
    return this.http.post(buildUrl(`${this.baseUrl}/api/company/${company.id}/jobs/delete`), null);
  }

  deleteOfflineJobsByCompanyId(company: Company): Observable<unknown> {
    return this.http.post(buildUrl(`${this.baseUrl}/api/company/${company.id}/jobs-offline/delete`), null);
  }
}
